import React from 'react'
import { View } from 'react-native'
import { BtInput } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'
import { TimePeriodModel as Model } from '@linqpal/models'

const TimePeriod = ({ model, value }) => {
  const { t } = useTranslation('global')
  const { firstFilled, lastFilled } = Model.create(value)

  const onChange = (val, field) => {
    model.setModelValue(field, val)
  }
  const validateFirstDay = () =>
    firstFilled ? false : t('ProjectForm.invalid-first-day')

  const validateLastDay = () =>
    lastFilled ? false : t('ProjectForm.invalid-last-day')

  const onKeyPress = (key: string) => (e) => {
    const val = e.target.value
    if (e.which === 8 && val[val.length - 1] === '/') {
      onChange(val.slice(0, val.length - 2), key)
    }
  }

  const onChangeText = (key: string) => (e) => {
    let val = e.target.value
    const valueLength = e.target.value.length
    if (valueLength === 2 || valueLength === 5) {
      val = e.target.value + '/'
    }
    onChange(val, key)
  }

  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        marginTop: 20,
      }}
    >
      <BtInput
        maskType="datetime"
        label={t('ProjectForm.first-day-on-job')}
        value={value.firstDayOnJob}
        onChange={onChangeText('firstDayOnJob')}
        onKeyPress={onKeyPress('firstDayOnJob')}
        maskOptions={{
          format: 'MM/DD/YYYY',
        }}
        placeholder={t('ProjectForm.date-placeholder')}
        containerStyle={{ maxHeight: 40, width: 290, borderRadius: 4 }}
        validateInput={validateFirstDay}
        validateInputOnBlur
      />
      <BtInput
        maskType="datetime"
        label={t('ProjectForm.last-day-on-job')}
        value={value.expectedLastDayOnJob}
        onChange={onChangeText('expectedLastDayOnJob')}
        onKeyPress={onKeyPress('expectedLastDayOnJob')}
        maskOptions={{
          format: 'MM/DD/YYYY',
        }}
        placeholder={t('ProjectForm.date-placeholder')}
        containerStyle={{ maxHeight: 40, width: 290, borderRadius: 4 }}
        validateInput={validateLastDay}
        validateInputOnBlur
      />
    </View>
  )
}

export default {
  identifier: 'timePeriod',
  title: '',
  component: TimePeriod,
  Model,
  optional: true,
}
